/**
 * @license
 * Copyright UX Stack. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at LICENSE.md
 */

export enum LoggerLevel {
  ERROR = 1,
  WARNING,
  INFO,
  DEBUG,
}

export class Logger {
  public static level = LoggerLevel.ERROR;

  public static debug(message?: string, ...optionalParams: any[]): void {
    if (Logger.level < LoggerLevel.DEBUG) {
      return;
    }

    console.debug(message, ...optionalParams);
  }

  public static info(message?: any, ...optionalParams: any[]): void {
    if (Logger.level < LoggerLevel.INFO) {
      return;
    }

    console.info(message, ...optionalParams);
  }

  public static warn(message?: any, ...optionalParams: any[]): void {
    if (Logger.level < LoggerLevel.WARNING) {
      return;
    }

    console.warn(message, ...optionalParams);
  }

  public static error(message?: any, ...optionalParams: any[]): void {
    if (Logger.level < LoggerLevel.ERROR) {
      return;
    }

    console.error(message, ...optionalParams);
  }
}
